import type { BasketItem } from '../types/order';
import { isStateFeeLine } from './reorderLine';

/**
 * Υποσύνολο του καλαθιού delivery (DeliveryWithMap calculateSubtotal), πριν τα μεταφορικά.
 *
 * ΓΙΑΤΙ ΕΔΩ: ζούσε μέσα στην οθόνη, οπότε το test «η έκπτωση παραγγελίας δεν πιάνει γραμμές
 * τελών» (F1-W5-11) ξανάγραφε τον υπολογισμό αντί να ασκεί αυτόν που πράγματι τρέχει. Η λογική
 * είναι ΑΥΤΟΥΣΙΑ η ίδια (ίδια αριθμητική κινητής υποδιαστολής, ίδια σειρά πράξεων) — καμία
 * αλλαγή ποσού, μόνο μετακίνηση για να δοκιμάζεται.
 *
 * Η έκπτωση παραγγελίας πιάνει ΜΟΝΟ τα έσοδα· τα τέλη (isStateFeeLine: κωδ. 8/16, και η
 * ιστορική γραμμή τέλους της επανάληψης) περνούν ολόκληρα.
 */
export interface DeliveryDiscount {
  discountType: 'percent' | 'fixed' | string;
  /** Ποσοστό (0–100) για discountType 'percent'. */
  orderDiscount: number;
  /** Ποσό σε € για discountType 'fixed'. */
  fixedDiscountAmount: number;
}

export function deliverySubtotal(basket: BasketItem[], { discountType, orderDiscount, fixedDiscountAmount }: DeliveryDiscount): number {
  let revenue = 0;
  let fees = 0;
  for (const item of basket) {
    const price = typeof item.price === 'number' ? item.price : parseFloat(String(item.price)) || 0;
    const line = price * item.quantity;
    if (isStateFeeLine(item)) fees += line;
    else revenue += line;
  }

  if (discountType === 'fixed' && fixedDiscountAmount > 0) {
    return Math.max(0, revenue - fixedDiscountAmount) + fees;
  }
  if (discountType === 'percent' && orderDiscount > 0) {
    return revenue * (1 - orderDiscount / 100) + fees;
  }
  return revenue + fees;
}
